<ng-container *ngIf="nzType === 'line'">
    <nz-progress
        [class]="className"
        [nzPercent]="percent"
        [nzShowInfo]="showInfo"
        [nz-tooltip]="showInfo ? '' : (percent + '%')"
        [nzStrokeColor]="nzStrokeColor"
        [nzStrokeWidth]="strokeWidth"
        [nzStrokeLinecap]="strokeLinecap"
        nzSize="small"
        nzStatus="active"
    ></nz-progress>
</ng-container>

<ng-container *ngIf="nzType === 'circle'">
    <nz-progress
        nzType="circle"
        [nzPercent]="percent"
        [nzShowInfo]="showInfo"
        [nzStrokeColor]="nzStrokeColor"
        [nzStrokeWidth]="strokeWidth"
        nzSize="small"
        nzStatus="active"
    ></nz-progress>
</ng-container>
